import React from 'react'
import { SwiperProps, SwiperSlide } from 'swiper/react'

import { graphql, useStaticQuery } from 'gatsby'

import Image from '@components/Content/Image/Image'
import Slider from '@components/Content/Slider/Slider'
import Wysiwyg from '@components/Content/Wysiwyg/Wysiwyg'

import { ExternalArticleType } from '@contracts/ExternalArticles'

import * as styles from './ExternalArticlesSlider.module.scss'

import Arrow from '@images/read_more_arrow.svg'

const ExternalArticlesSlider = () => {
	const data = useStaticQuery(graphql`
		query ExternalArticles {
			allWpExternalArticle {
				nodes {
					id
					title
					content
					externalArticlesOptions {
						link
						image {
							mimeType
							localFile {
								publicURL
								childImageSharp {
									gatsbyImageData(height: 50)
								}
							}
						}
					}
				}
			}
		}
	`)

	const articles: ExternalArticleType[] = data.allWpExternalArticle.nodes

	const articlesSlides = articles.map((article) => {
		return (
			<SwiperSlide key={article.id} className={styles.slide}>
				<div className={styles.image}>
					<Image image={article.externalArticlesOptions.image} altText={article.title} />
				</div>

				<Wysiwyg content={article.content} />

				<hr />

				<span className={styles.link}>
					Read the full article{' '}
					<a href={article.externalArticlesOptions.link} target="_blank" rel="noreferrer">
						here <Arrow />
					</a>
				</span>
			</SwiperSlide>
		)
	})

	const sliderOptions: SwiperProps = {
		loop: true,
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 16,
			},
			1280: {
				slidesPerView: 2.5,
				spaceBetween: 16,
			},
		},
	}

	return <Slider slides={articlesSlides} options={sliderOptions} className={styles.slider} />
}

export default ExternalArticlesSlider
